import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { default as ReactSelect } from "react-select";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

function AddNewContactModal({
  show,
  contact,
  handleClose,
  errors,
  handleContactSubmit,
  handleChange,
  department,
  designation,
  departmentData,
  designationData,
  handleDepartmentChange,
  handleDesignationChange,
  setDesignation,
  setDepartment,
  setContact,
  setErrors
}) {
  const style = {
    control: (base) => ({
      ...base,
      boxShadow: "none",
      border: "1px solid #B4BABF",
      backgroundColor: "#F9FBFC",
      fontSize: "14px",
      minHeight: "35px",
      height: "35px",
      borderRadius: "6px",
      color: "#000811",
      whiteSpace: "nowrap",
    }),
  };

  return (
    <Modal show={show} centered size="xl" className="addNewContactModal" dialogClassName="viewport-centered-modal-dialog">
      <Modal.Header>
        <div className="">
          <h6>{contact?.id > 0 ? "Edit Contact" : "New Contact"}</h6>
        </div>
        <div className="">
          <i className="fas fa-times" onClick={(e) => handleClose(e)}></i>
          {/* <i className="far fa-edit" title="Edit"></i> */}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Contact Person <span className="mandatory">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter name"
                name="name"
                value={contact?.name}
                onChange={(e) => handleChange(e)}
              ></input>
              {errors.name && <p className="form-error ">{errors.name}</p>}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Email <span className="mandatory">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter email"
                name="email"
                value={contact?.email}
                onChange={(e) => handleChange(e)}
              ></input>
              {errors.email && <p className="form-error ">{errors.email}</p>}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Phone Number <span className="mandatory">*</span>
              </label>
              <PhoneNumberComponent errors={errors} setValues={setContact} setErrors={setErrors} filedName="phone" values={contact} />
              {errors.phone && <p className="form-error ">{errors.phone}</p>}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Department <span className="mandatory">*</span>
              </label>
              <DropDownComponent
                placeholder={PlaceHolder.SELECT_DEPARTMENT}
                pageName="distributor"
                dpDownName="department"
                controlName="department"
                stateData={departmentData}
                handleChange={handleDepartmentChange}
                value={department}
                valueId={contact?.departmentId}
                setState={setDepartment} />

              {errors.department && (
                <p className="form-error ">{errors.department}</p>
              )}
            </div>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>
                Designation <span className="mandatory">*</span>
              </label>
              <DropDownComponent
                placeholder={PlaceHolder.SELECT_DESIGNATION}
                pageName="distributor"
                dpDownName="designation"
                controlName="designation"
                stateData={designationData}
                handleChange={handleDesignationChange}
                value={designation}
                valueId={contact?.designationId}
                setState={setDesignation} />
              {errors.designation && (
                <p className="form-error ">{errors.designation}</p>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mt-3">
              <button
                type="button"
                className="btn cancel-btn"
                onClick={(e) => handleClose(e)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn save-btn"
                onClick={handleContactSubmit}
              >
                {" "}
                {contact?.id > 0 ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddNewContactModal;
